<div [hidden]="isGuest" class="mt-3" *ngIf="style === tableStyle.Short">
  <div class="table-title card-header"
       [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex align-items-center">
      <div class="d-flex align-items-center">
        <h4 class="mb-0">
          <a>
            <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
          </a>
          {{tableTitle}}
        </h4>
        <button class="mat-focus-indicator btn-excel ml-3 mat-icon-button mat-button-base" mat-icon-button (click)="downloadExcel()"
                *ngIf="(userIsProfessional || userIsAdmin) && !downloadExcelLoader.isActive()">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        </button>
        <app-loader class="ml-4" *ngIf="downloadExcelLoader.isActive()"></app-loader>
      </div>
      <a>
        <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
          class="fa fa-info-circle fa-sm"></i></button>
      </a>
    </div>
  </div>
  <div class="table-responsive"
       [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
           (matSortChange)="sendSortingParam($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col" mat-sort-header="Isin">Isin</th>
        <th scope="col" mat-sort-header="Nome">Nome</th>
        <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
        <th scope="col" mat-sort-header="Barriera">Barriera</th>
        <th scope="col" mat-sort-header="Buffer">Buffer</th>
        <th scope="col" mat-sort-header="Bonus">Bonus</th>
        <th scope="col" mat-sort-header="Cap">Cap</th>
        <th scope="col" mat-sort-header="Prezzo Sott.">Prezzo Sott.</th>
        <th scope="col" mat-sort-header="Prezzo Cert.">Prezzo Cert.</th>
        <th scope="col" mat-sort-header="Upside">Upside</th>
        <th scope="col" mat-sort-header="CedProb">CedProb</th>
        <th scope=col></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of store.sortedRecords">
        <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin}}</a>
        </td>
        <td>{{record.nome}}</td>
        <td>{{record.scadenza | date: 'dd/MM/yyyy'}}</td>
        <td>{{record.barriera | number:'1.0-2':'fr'}}</td>
        <td [style.color]=" record.buffer < 0 ? 'red' : 'null'">{{record.buffer | percent:'1.0-2':'fr'}}</td>
        <td>{{record.bonus | number:'1.0-2':'fr'}}</td>
        <td>{{record.cap | number:'1.0-2':'fr'}}</td>
        <td>{{record.prezzosott | number:'1.0-4':'fr'}}</td>

        <td>{{record.prezzocert ? (record.prezzocert | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>

        <td [style.color]=" record.upside < 0 ? 'red' : 'null'">{{record.upside / 100 | percent:'1.0-2':'fr'}}</td>
        <td [style.color]=" record.cedprob < 0 ? 'red' : 'null'">{{record.cedprob / 100 | percent:'1.0-2':'fr'}}</td>
        <td>
          <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
            <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot *ngIf="!showLoader" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="store.viewAllPath">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <app-loader *ngIf="showLoader"></app-loader>
    </div>
  </div>
</div>

<div [hidden]="isGuest" class="container-fluid mt-3" style="position: relative" *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="view-all-table-title">
      {{tableTitle}}
    </h4>
    <mat-form-field class="ml-auto" *ngIf="store.totalRecords > 20">
      <mat-label>Elementi per pagina</mat-label>
      <select matNativeControl (change)="updateSize($event)">
        <option value="20" selected>20</option>
        <option value="30">30</option>
        <option value="40">40</option>
      </select>
    </mat-form-field>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
        class="fa fa-info-circle fa-sm"></i></button>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
           (matSortChange)="deepSortRecords($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col" mat-sort-header="isin">Isin</th>
        <th scope="col" mat-sort-header="emittente">Emittente</th>
        <th scope="col" mat-sort-header="nome">Nome</th>
        <th scope="col" mat-sort-header="sottostante">Sottostante</th>
        <th scope="col" mat-sort-header="scadenza">Scadenza</th>
        <th scope="col" mat-sort-header="barriera">Barriera</th>
        <th scope="col" mat-sort-header="buffer">Buffer</th>
        <th scope="col" mat-sort-header="bonus">Bonus</th>
        <th scope="col" mat-sort-header="cap">Cap</th>
        <th scope="col" mat-sort-header="prezzosott">Prezzo Sott.</th>
        <th scope="col" mat-sort-header="prezzocert">Prezzo Cert</th>
        <th scope="col" mat-sort-header="upside">Upside</th>
        <th scope="col" mat-sort-header="rendimentoAnnuo">Upside A/A</th>
        <th scope="col" mat-sort-header="cedProb">CedProb</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of store.sortedRecords">
        <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin}}</a>
        </td>
        <td>{{record.emittente}}</td>
        <td>{{record.nome}}</td>
        <td *ngIf="record.sottostante">
          <a [routerLink]="[ '/menu/sottostante']"
             [queryParams]="{ sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a>
        </td>
        <td *ngIf="!record.sottostante">
          n/a
        </td>
        <td>{{record.scadenza | date: 'dd/MM/yyyy'}}</td>
        <td>{{record.barriera | number:'1.0-2':'fr'}}</td>
        <td [style.color]="record.buffer < 0 ? 'red' : 'null'">{{record.buffer | percent:'1.0-2':'fr'}}</td>
        <td>{{record.bonus | number:'1.0-2':'fr'}}</td>
        <td>{{record.cap | number:'1.0-2':'fr'}}</td>
        <td>{{record.prezzosott | number:'1.0-4':'fr'}}</td>
        <td>{{record.prezzocert ? (record.prezzocert | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>
        <td [style.color]="record.upside < 0 ? 'red' : 'null'">{{record.upside / 100 | percent:'1.0-2':'fr'}}</td>
        <td
          [style.color]="record.rendimentoAnnuo < 0 ? 'red' : 'null'">{{record.rendimentoAnnuo / 100 | percent:'1.0-2':'fr'}}</td>
        <td [style.color]="record.cedprob < 0 ? 'red' : 'null'">{{record.cedprob / 100 | percent:'1.0-2':'fr'}}</td>
        <td>
          <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
            <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div style="padding-top: 15px" *ngIf="store.totalRecords > pageSize">
    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li class="page-item">
          <a class="page-link" (click)="firstPage()">First</a>
        </li>
        <li [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="previousPage()" title="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item active">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="nextPage()" title="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="lastPage()">Last</a>
        </li>
      </ul>
    </nav>
  </div>
  <div [ngClass]="showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="showLoader"></app-loader>
  </div>
</div>


<div [hidden]="!isGuest" class="mt-3" *ngIf="style === tableStyle.Short">
  <div class="table-title card-header"
       [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
        {{tableTitle}}
      </h4>
      <a>
        <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
          class="fa fa-info-circle fa-sm"></i></button>
      </a>
    </div>
  </div>
  <div class="table-responsive"
       [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
           (matSortChange)="sendSortingParamGuest($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col" mat-sort-header="Isin">Isin</th>
        <th scope="col" mat-sort-header="Nome">Nome</th>
        <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
        <th scope="col" mat-sort-header="Barriera">Barriera</th>
        <th scope="col" mat-sort-header="Buffer">Buffer</th>
        <th scope="col" mat-sort-header="Bonus">Bonus</th>
        <th scope="col" mat-sort-header="Cap">Cap</th>
        <th scope="col" mat-sort-header="Prezzo Sott.">Prezzo Sott.</th>
        <th scope="col" mat-sort-header="Prezzo Cert.">Prezzo Cert.</th>
        <th scope="col" mat-sort-header="Upside">Upside</th>
        <th scope="col" mat-sort-header="CedProb">CedProb</th>
        <th scope=col></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of store.sortedRecordsGuest">
        <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin}}</a>
        </td>
        <td>{{record.nome}}</td>
        <td>{{record.scadenza | date: 'dd/MM/yyyy'}}</td>
        <td>{{record.barriera | number:'1.0-2':'fr'}}</td>
        <td [style.color]=" record.buffer < 0 ? 'red' : 'null'">{{record.buffer | percent:'1.0-2':'fr'}}</td>
        <td>{{record.bonus | number:'1.0-2':'fr'}}</td>
        <td>{{record.cap | number:'1.0-2':'fr'}}</td>
        <td>{{record.prezzosott | number:'1.0-4':'fr'}}</td>
        <td>{{record.prezzocert | number:'1.0-2':'fr'}}</td>
        <td [style.color]=" record.upside < 0 ? 'red' : 'null'">{{record.upside / 100 | percent:'1.0-2':'fr'}}</td>
        <td [style.color]=" record.cedprob < 0 ? 'red' : 'null'">{{record.cedprob / 100 | percent:'1.0-2':'fr'}}</td>
        <td>
          <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
            <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot *ngIf="!showLoader" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="store.viewAllPath">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <app-loader *ngIf="showLoader"></app-loader>
    </div>
  </div>
</div>


<div [hidden]="!isGuest" class="container-fluid mt-3" style="position: relative" *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="view-all-table-title">
      {{tableTitle}}
    </h4>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
        class="fa fa-info-circle fa-sm"></i></button>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
           (matSortChange)="sendSortingParamGuest($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col" mat-sort-header="Isin">Isin</th>
        <th scope="col" mat-sort-header="Emittente">Emittente</th>
        <th scope="col" mat-sort-header="Nome">Nome</th>
        <th scope="col" mat-sort-header="Sottostante">Sottostante</th>
        <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
        <th scope="col" mat-sort-header="Barriera">Barriera</th>
        <th scope="col" mat-sort-header="Buffer">Buffer</th>
        <th scope="col" mat-sort-header="Bonus">Bonus</th>
        <th scope="col" mat-sort-header="Cap">Cap</th>
        <th scope="col" mat-sort-header="Prezzosott">Prezzo Sott.</th>
        <th scope="col" mat-sort-header="Prezzocert">Prezzo Cert</th>
        <th scope="col" mat-sort-header="Upside">Upside</th>
        <th scope="col" mat-sort-header="CedProb">CedProb</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of store.sortedRecordsGuest">
        <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin}}</a>
        </td>
        <td>{{record.emittente}}</td>
        <td>{{record.nome}}</td>
        <td *ngIf="record.sottostante">
          <a [routerLink]="[ '/menu/sottostante']"
             [queryParams]="{ sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a>
        </td>
        <td *ngIf="!record.sottostante">
          n/a
        </td>
        <td>{{record.scadenza | date: 'dd/MM/yyyy'}}</td>
        <td>{{record.barriera | number:'1.0-2':'fr'}}</td>
        <td [style.color]="record.buffer < 0 ? 'red' : 'null'">{{record.buffer | percent:'1.0-2':'fr'}}</td>
        <td>{{record.bonus | number:'1.0-2':'fr'}}</td>
        <td>{{record.cap | number:'1.0-2':'fr'}}</td>
        <td>{{record.prezzosott | number:'1.0-4':'fr'}}</td>
        <td>{{record.prezzocert | number:'1.0-2':'fr'}}</td>
        <td [style.color]="record.upside < 0 ? 'red' : 'null'">{{record.upside / 100 | percent:'1.0-2':'fr'}}</td>
        <td [style.color]="record.cedprob < 0 ? 'red' : 'null'">{{record.cedprob / 100 | percent:'1.0-2':'fr'}}</td>
        <td>
          <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
            <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div [ngClass]="showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="showLoader"></app-loader>
  </div>
</div>

